import { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import { Auth0Wrapper } from 'utils/authentication';
import { Loader } from 'components/Questionnaire';
import Snackbar from 'components/Snackbar';
import { ProfileImageContextProvider } from 'context/ProfileImageContext';
import 'formio/index.js';
import { selectIsInitialized, initialize } from 'store/initialize';
import { loadConfig } from 'utils/environment';
import PKDRoutes from './routes';

const App = () => {
  const isInitialized = useSelector(selectIsInitialized());

  const dispatch = useDispatch();

  useEffect(() => {
    (async function () {
      if (!isInitialized) {
        const config = await loadConfig();
        dispatch(initialize(config));
      }
    })();
  }, [isInitialized, dispatch]);
  
  return (
    <>
      {isInitialized
        ? (
          <Auth0Wrapper>
            <BrowserRouter>
              <ProfileImageContextProvider>
                <PKDRoutes />
                <Snackbar />
              </ProfileImageContextProvider>
            </BrowserRouter>
          </Auth0Wrapper>
        )
        : (
          <Loader />
        )}
    </>
  );
};

/** TODO: remove the added space to check for HRS2.0 */
export default App;
